import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject, Subscription, timer } from 'rxjs';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import { ApplicationControlService } from '../services/applicationcontrol.service';
import { UtilService } from '../services/util.service';
import {
    APIResponse,
    RecordLock,
    RecordLockType,
    RecordType,
    SearchRecordLock
} from '../models/models';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class RecordLockService {
    public isLocked: boolean = false;
    public isTimeout: boolean = false;
    public recordID: number = 0;
    public lockSource: string = "";
    public recordLock: RecordLock = {} as RecordLock;
    public recordLockList: RecordLock[] = [];
    public recordType: RecordType = {} as RecordType;
    public recordLockTypeList: RecordLockType[] = [];
    public recordTypeList: RecordType[] = [];
    public searchRecordLock: SearchRecordLock = {} as SearchRecordLock;
    public searchRecordLockList: SearchRecordLock[] = [];
    public recordLockedIDList: number[] = [];
    public isContinueRecordLock: boolean = false;
    public isCancelOverride: boolean = false;
    public isRecordLockTimeout: boolean = false;
    public isConfirmTimeout: boolean = false;
    public hasRecordLock: boolean = false;
    public isRefreshNeeded: boolean = false;
    private recordLockDefaultMinutes: number = 15;
    //private recordLockTimeoutDate: Date = new Date();
    public continueRecordLockObserver: Subject<boolean> = new Subject<boolean>();
    public cancelOverrideObserver: Subject<boolean> = new Subject<boolean>();
    public timeoutRecordLockObserver: Subject<boolean> = new Subject<boolean>();
    public timeoutConfirmObserver: Subject<boolean> = new Subject<boolean>();
    public hasRecordLockObserver: Subject<boolean> = new Subject<boolean>();
    private lockTimer: Observable<any> = new Observable<any>;
    private lockTimerSub: Subscription = new Subscription;
    private contactUrl: string = '';

    constructor(private applicationControlService: ApplicationControlService, private utilService: UtilService,
        private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
        this.contactUrl = baseUrl + 'api/RecordLock/';

        this.getRecordLockTypes().subscribe(result => {
            this.recordLockTypeList = result.resultCollection;
        });

        this.getRecordTypes().subscribe(result => {
            this.recordTypeList = result.resultCollection;
        });

        this.applicationControlService.getApplicationControlsByAppName("RecordLockDefaultMinutes", false).subscribe(result => {
            if (result.length > 0) {
                var appValue = result[0].appSettingValue;
                this.recordLockDefaultMinutes = parseInt(appValue);
            }
        });

        // Watch variables
        this.continueRecordLockObserver.subscribe(value => this.isContinueRecordLock = value);
        this.cancelOverrideObserver.subscribe(value => this.isCancelOverride = value);
        this.timeoutRecordLockObserver.subscribe(value => this.isRecordLockTimeout = value);
        this.timeoutConfirmObserver.subscribe(value => this.isConfirmTimeout = value);
        this.hasRecordLockObserver.subscribe(value => this.hasRecordLock = value);
    }

    public resetRecordLock() {
        console.log("resetRecordLock");
        this.isLocked = false;
        this.isTimeout = false;
        this.isRefreshNeeded = false;
        this.recordLock = {} as RecordLock;
        this.recordLockList = [];
        this.searchRecordLock = {} as SearchRecordLock;
        this.searchRecordLockList = [];
        this.recordLockedIDList = [];
        this.continueRecordLockObserver.next(false);
        this.cancelOverrideObserver.next(false);
        this.timeoutRecordLockObserver.next(false);
        this.timeoutConfirmObserver.next(false);
        this.hasRecordLockObserver.next(false);
        this.lockTimerSub.unsubscribe;
    }

    public checkHasRecordLock(recordTypeName: string, id: number, lockSource: string) {
        this.recordType = this.recordTypeList.find(r => r.recordTypeName == recordTypeName) as RecordType;

        this.getSearchRecordLockByRecordTypeNameRecordID(recordTypeName, id).subscribe(result => {
            var hasLock = false;
            if (result.resultCollection.length > 0) {
                //console.log("handleRecordLock:searchRecordLock", employeeID, id, result);
                var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
                var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                // See if current checked out record is for this employee and lock source
                var employeeCol = searchCol.filter(t => t.releasedByEmployeeID == null && t.checkedOutByEmployeeID == employeeID && t.lockSource == lockSource && t.recordLockTypeName == "Overridable");
                console.log("recordLockService.checkHasRecordLock", employeeID, recordTypeName, id, lockSource, employeeCol, searchCol);
                if (employeeCol.length > 0) {
                    hasLock = true;
                }
                else {
                    var otherCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                    if (otherCol.length > 0) {
                        // Current lock is by someone else, so update the lock popup info
                        this.searchRecordLock = otherCol[0];
                        this.getRecordLockByID(this.searchRecordLock.recordLockID).subscribe(resp => {
                            this.recordLock = resp.resultCollection[0];
                        });
                        this.isLocked = true;
                    }
                    else {
                        // There is no current lock, so get a new one
                        this.isRefreshNeeded = true;
                        //this.timeoutConfirmObserver.next(true);
                        //this.resetRecordLock();
                        //this.handleRecordLock(recordTypeName, id, lockSource);
                    }
                }
            }
            console.log("recordLockService.checkHasRecordLock", hasLock);

            this.hasRecordLockObserver.next(hasLock);
        });
    }

    public checkHasRecordLockList(recordTypeName: string, idList: number[], lockSource: string) {
        this.recordType = this.recordTypeList.find(r => r.recordTypeName == recordTypeName) as RecordType;
        this.recordLock = {} as RecordLock;

        this.getSearchRecordLockByRecordTypeNameRecordIDList(recordTypeName, idList).subscribe(result => {
            var hasLock = false;
            if (result.resultCollection.length > 0) {
                var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
                var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                // See if current checked out record is for this employee and lock source
                var employeeCol = searchCol.filter(t => t.releasedByEmployeeID == null && t.checkedOutByEmployeeID == employeeID && t.lockSource == lockSource && t.recordLockTypeName == "Overridable");
                console.log("recordLockService.checkHasRecordLockList", employeeID, recordTypeName, idList, lockSource, employeeCol, searchCol);
                if (employeeCol.length == idList.length) {
                    hasLock = true;
                }
                else {
                    var otherCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                    if (otherCol.length > 0) {
                        // Current lock is by someone else, so update the lock popup info
                        this.searchRecordLockList = otherCol;
                        this.recordLockList = [];
                        this.recordLockedIDList = [];
                        for (var i = 0; i < idList.length; i++) {
                            var searchLock = otherCol.find(t => t.recordID == idList[i]);
                            if (searchLock != null) {
                                this.recordLockedIDList.push(idList[i]);
                                this.getRecordLockByID(this.searchRecordLock.recordLockID).subscribe(resp => {
                                    if (resp.resultCollection.length > 0) {
                                        this.recordLockList.push(resp[0]);
                                    }
                                });
                            }
                        }
                        this.isLocked = true;
                    }
                    else {
                        // There is no current lock, so get a new one
                        this.isRefreshNeeded = true;
                        //this.timeoutConfirmObserver.next(true);
                        //this.resetRecordLock();
                        //this.handleRecordLock(recordTypeName, id, lockSource);
                    }
                }
            }
            console.log("recordLockService.checkHasRecordLockList", hasLock);

            this.hasRecordLockObserver.next(hasLock);
        });
    }

    public handleRecordLock(recordTypeName: string, id: number, lockSource: string) {
        this.isTimeout = false;
        this.recordID = id;
        this.lockSource = lockSource;
        this.recordType = this.recordTypeList.find(r => r.recordTypeName == recordTypeName) as RecordType;
        //var recordTypeID = this.recordTypeList.find(r => r.recordTypeName == recordTypeName)!.recordTypeID;
        //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

        //console.log("handleRecordLock", id, actionType, recordTypeID, employeeID);

        // Clear all locks for this employee before handling the current record
        //    this.recordLockService.clearRecordLockByRecordTypeEmployee(recordTypeID, employeeID).subscribe(clearResult => {
        //        var col = clearResult.resultCollection;
        //    });
        // Handle the lock for this record
        this.getSearchRecordLockByRecordTypeNameRecordID(recordTypeName, id).subscribe(result => {
            var canLock = false;
            if (result.resultCollection.length > 0) {
                //console.log("handleRecordLock:searchRecordLock", employeeID, id, result);
                var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                searchCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                this.searchRecordLock = searchCol[0];
                //console.log("recordLockService.handleRecordLock: searchRecordLock", this.searchRecordLock);
                if (this.searchRecordLock != null) {
                    if (this.searchRecordLock.recordLockTypeName == "Unlocked") {
                        canLock = true;
                    }
                    this.getRecordLockByID(this.searchRecordLock.recordLockID).subscribe(resp => {
                        this.recordLock = resp.resultCollection[0];
                    });
                }
                else {
                    canLock = true;
                }
                //console.log("recordLockService.handleRecordLock: searchRecordLock", this.searchRecordLock, this.recordLock);
            }
            else {
                canLock = true;
            }
            console.log("recordLockService.handleRecordLock: before setRecordLock", this.searchRecordLock, this.isLocked, canLock);
            if (canLock) {
                this.setRecordLock(recordTypeName, id, lockSource);
            }
            if (canLock || this.searchRecordLock == undefined) {
                this.isLocked = false;
            }
            else {
                this.isLocked = true;
            }

            //console.log("recordLockService.handleRecordLock: after setRecordLock", id, this.isLocked, this.recordLock);
            this.continueRecordLockObserver.next(true);
            //continueCallback();
            //this.continueRecordLockAction();
            //console.log("handleRecordLock", this.searchRecordLock, this.isLocked, canLock);
        });
    }

    public handleRecordLockList(recordTypeName: string, idList: number[], lockSource: string) {
        this.isTimeout = false;
        this.recordID = idList[0];
        this.recordLockedIDList = [];
        this.lockSource = lockSource;
        this.recordType = this.recordTypeList.find(r => r.recordTypeName == recordTypeName) as RecordType;

        // Handle the lock for these records
        this.getSearchRecordLockByRecordTypeNameRecordIDList(recordTypeName, idList).subscribe(result => {
            var canLock = false;
            console.log("recordLockService.handleRecordLockList: before checks", idList, result);
            if (result.resultCollection.length > 0) {
                //console.log("handleRecordLock:searchRecordLock", employeeID, id, result);
                var searchColOrig: SearchRecordLock[] = Object.assign([], result.resultCollection);
                this.searchRecordLockList = searchColOrig;
                var canLockList: number[] = [];
                for (var i = 0; i < idList.length; i++) {
                    // Find records with matching RecordID that are not released and either mismatched LockSource or are not Unlocked
                    var searchCol: SearchRecordLock[] = searchColOrig.filter(t => t.recordID == idList[i]
                        && t.releasedByEmployeeID == null
                        && (t.lockSource != lockSource || t.recordLockTypeName != "Unlocked")
                    );
                    console.log("recordLockService.handleRecordLockList: searchCol", idList[i], searchCol);
                    if (searchCol.length == 0) {
                        canLockList.push(idList[i]);
                    }
                    else {
                        this.recordLockedIDList.push(idList[i]);
                    }
                }
                if (canLockList.length == idList.length) {
                    canLock = true;
                }
                else {
                    canLock = false;
                }
                console.log("recordLockService.handleRecordLockList: searchRecordLockList", canLock, this.searchRecordLockList, this.recordLockList);
            }
            else {
                canLock = true;
            }
            console.log("recordLockService.handleRecordLockList: before setRecordLockList", canLock, idList, this.searchRecordLockList, this.isLocked);
            if (canLock) {
                this.setRecordLockList(recordTypeName, idList, lockSource);
                this.isLocked = false;
            }
            else {
                this.isLocked = true;
            }

            //console.log("recordLockService.handleRecordLock: after setRecordLock", id, this.isLocked, this.recordLock);
            this.continueRecordLockObserver.next(true);
            //continueCallback();
            //this.continueRecordLockAction();
            //console.log("handleRecordLock", this.searchRecordLock, this.isLocked, canLock);
        });
    }

    private setRecordLock(type: string, id: number, lockSource: string) {
        //var lockSource: string = "Stops Grid";
        //if (this.pageType == "orderentry") {
        //    lockSource = "Order Entry: Stops Grid";
        //}
        //else if (this.pageType == "carriersales") {
        //    lockSource = "Procurement: Stops Grid";
        //}
        //else if (this.pageType == "tracking") {
        //    lockSource = "Tracking Dashboard";
        //}

        var recordLockType = this.recordLockTypeList.find(r => r.recordLockTypeName == "Overridable");
        if (this.searchRecordLock != null && this.searchRecordLock.recordLockID) {
            // Update existing Unlocked record
            this.recordLock = {
                recordLockID: this.searchRecordLock.recordLockID,
                recordLockTypeID: recordLockType!.recordLockTypeID,
                recordTypeID: this.searchRecordLock.recordTypeID,
                recordID: id,
                checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                lockSource: lockSource
                //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                //dateReleased: new Date()
            }
        }
        else {
            // Create new lock if not found
            var recordType = this.recordTypeList.find(r => r.recordTypeName == type);
            if (recordLockType != null && recordType != null) {
                this.recordLock = {
                    recordLockID: 0,
                    recordLockTypeID: recordLockType.recordLockTypeID,
                    recordTypeID: recordType.recordTypeID,
                    recordID: id,
                    checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                    lockSource: lockSource
                    //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    //dateReleased: new Date()
                }
            }
            //console.log("setRecordLock:null", id, type, recordLockType, recordType);
        }

        //console.log("recordLockService.setRecordLock", id, type, lockSource, this.recordLock, this.searchRecordLock);
        this.saveRecordLock(this.recordLock).subscribe(result => {
            if (result.resultCollection.length > 0) {
                //console.log("recordLockService.setRecordLock:saveRecordLock", result);
                this.recordLock = result.resultCollection[0];
                this.getSearchRecordLockByRecordTypeNameRecordID(type, id).subscribe(result => {
                    var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                    searchCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                    this.searchRecordLock = searchCol[0];
                    //console.log("recordLockService.setRecordLock: searchRecordLock", this.searchRecordLock);
                });
                this.setRecordLockTimeout();
                //this.handleRecordLock(id);
            }
            else {
                //console.log("recordLockService.setRecordLock:saveRecordLock:FAIL", result);
                // Failed to acquire lock (eg. two people clicked at same time)
                //this.handleRecordLock(id);
            }
        });
    }

    private setRecordLockList(type: string, idList: number[], lockSource: string) {
        var recordLockType = this.recordLockTypeList.find(r => r.recordLockTypeName == "Overridable");
        var recordType = this.recordTypeList.find(r => r.recordTypeName == type);
        this.recordLockList = [];
        for (var i = 0; i < idList.length; i++) {
            var searchLock = this.searchRecordLockList.find(t => t.recordID == idList[i]);
            var recordLock: RecordLock = {} as RecordLock;
            if (searchLock != null) {
                // Update existing Unlocked record
                recordLock = {
                    recordLockID: searchLock.recordLockID,
                    recordLockTypeID: recordLockType!.recordLockTypeID,
                    recordTypeID: searchLock.recordTypeID,
                    recordID: idList[i],
                    checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                    lockSource: lockSource
                    //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                    //dateReleased: new Date()
                }
                this.recordLockList.push(recordLock);
            }
            else {
                // Create new lock if not found
                var recordType = this.recordTypeList.find(r => r.recordTypeName == type);
                if (recordLockType != null && recordType != null) {
                    recordLock = {
                        recordLockID: 0,
                        recordLockTypeID: recordLockType.recordLockTypeID,
                        recordTypeID: recordType.recordTypeID,
                        recordID: idList[i],
                        checkedOutByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                        dateCheckedOut: this.utilService.getDateAsUTC(new Date()),
                        lockSource: lockSource
                        //releasedByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
                        //dateReleased: new Date()
                    }
                    this.recordLockList.push(recordLock);
                }
                //console.log("setRecordLock:null", id, type, recordLockType, recordType);
            }
        }

        console.log("recordLockService.setRecordLockList", idList, type, lockSource, this.recordLockList, this.searchRecordLockList);
        this.saveRecordLockList(this.recordLockList).subscribe(result => {
            if (result.resultCollection.length > 0) {
                //console.log("recordLockService.setRecordLock:saveRecordLock", result);
                this.recordLockList = result.resultCollection;
                this.getSearchRecordLockByRecordTypeNameRecordIDList(type, idList).subscribe(result => {
                    var searchCol: SearchRecordLock[] = Object.assign([], result.resultCollection);
                    searchCol = searchCol.filter(t => t.releasedByEmployeeID == null);
                    this.searchRecordLockList = searchCol;
                    console.log("recordLockService.setRecordLockList: searchRecordLockList", this.searchRecordLockList);
                });
                this.setRecordLockTimeout();
                //this.handleRecordLock(id);
            }
            else {
                //console.log("recordLockService.setRecordLock:saveRecordLock:FAIL", result);
                // Failed to acquire lock (eg. two people clicked at same time)
                //this.handleRecordLock(id);
            }
        });
    }

    public overrideRecordLock() {
        //public overrideRecordLock(id: number, lockSource: string) {
        var id: number = this.recordID;
        var lockSource: string = this.lockSource;
        console.log("recordLockService.overrideRecordLock", id, this.recordLock);
        if (this.recordLock && this.recordLock.recordID == id) {
            this.recordLock.recordLockTypeID = this.recordLockTypeList.find(r => r.recordLockTypeName == "Overridable")!.recordLockTypeID;
            this.recordLock.checkedOutByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.recordLock.dateCheckedOut = this.utilService.getDateAsUTC(new Date());
            this.recordLock.releasedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.recordLock.dateReleased = this.utilService.getDateAsUTC(new Date());
            this.recordLock.lockSource = lockSource;

            this.saveRecordLock(this.recordLock).subscribe(result => {
                //console.log("recordLockService.overrideRecordLock:saveRecordLock", id, result, this.recordLock);
                if (result.resultCollection.length > 0) {
                    this.recordLock = result.resultCollection[0];
                    this.setRecordLockTimeout();
                    this.isLocked = false;
                    //this.continueRecordLockAction.emit();
                    //continueCallback();
                    this.continueRecordLockObserver.next(true);
                }
            });
        }
    }

    //public clearRecordLock(recordLockID: number) {
    //    if (this.recordTypeList.length > 0) {
    //        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

    //        // Clear all locks for this employee before handling the current record
    //        this.clearRecordLockByID(recordLockID, employeeID).subscribe(result => {
    //            var col = result.resultCollection;
    //            this.isLocked = false;
    //        });
    //    }
    //    //this.resetRecordLock();
    //}

    public clearRecordLock(recordTypeName: string, recordID: number, lockSource: string) {
        if (this.recordTypeList.length > 0) {
            var recordTypeID = this.recordTypeList.find(r => r.recordTypeName == recordTypeName)!.recordTypeID;
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

            // Clear all locks for this employee before handling the current record
            //this.clearRecordLockByRecordTypeEmployeeRecord(recordTypeID, employeeID, recordID).subscribe(result => {
            //    var col = result.resultCollection;
            //    this.isLocked = false;
            //});
            this.clearRecordLockByLockSource(recordTypeID, employeeID, recordID, lockSource).subscribe(result => {
                var col = result.resultCollection;
                this.isLocked = false;
            });
        }
        //this.resetRecordLock();
    }

    public clearRecordLockObservable(recordTypeName: string, recordID: number, lockSource: string): Observable<APIResponse> {
        var isClearLock: boolean = false;
        var recordTypeID = 0;
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

        if (this.recordTypeList.length > 0) {
            recordTypeID = this.recordTypeList.find(r => r.recordTypeName == recordTypeName)!.recordTypeID;
            isClearLock = true;
        }

        if (isClearLock) {
            // Clear all locks for this employee before handling the current record
            //this.clearRecordLockByRecordTypeEmployeeRecord(recordTypeID, employeeID, recordID).subscribe(result => {
            //    var col = result.resultCollection;
            //    this.isLocked = false;
            //});
            this.isLocked = false;
            return this.clearRecordLockByLockSource(recordTypeID, employeeID, recordID, lockSource);
        }
        else {
            return of<APIResponse>({
                statusCode: 200,
                totalRecords: 0,
                message: "OK",
                resultCollection: [],
                errorCollection: [],
                validationCollection: []
            });
        }
        //this.resetRecordLock();
    }

    public clearRecordLockList(recordTypeName: string, recordIDList: number[], lockSource: string) {
        if (this.recordTypeList.length > 0) {
            var recordTypeID = this.recordTypeList.find(r => r.recordTypeName == recordTypeName)!.recordTypeID;
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

            this.clearRecordLockListByLockSource(recordTypeID, employeeID, recordIDList, lockSource).subscribe(result => {
                var col = result.resultCollection;
                this.isLocked = false;
            });
        }
        //this.resetRecordLock();
    }

    private setRecordLockTimeout() {
        //this.recordLockTimeoutDate = this.utilService.addMinutes(new Date(), this.recordLockDefaultMinutes);
        var timeoutMsec = this.recordLockDefaultMinutes * 60 * 1000;
        //timeoutMsec = 15000;
        console.log("recordLockService.setRecordLockTimeout", this.recordLockDefaultMinutes, timeoutMsec);

        this.lockTimer = timer(timeoutMsec);
        this.lockTimerSub = this.lockTimer.subscribe(result => {
            console.log("recordLockService.setRecordLockTimeout:timeoutRecordLockObserver");
            //this.isTimeout = true;
            //this.timeoutRecordLockObserver.next(true);
        });
    }

    public getRecordLockTypes() {
        return this.http.get<APIResponse>(this.contactUrl + 'GetRecordLockTypes/');
    }

    public getRecordTypes() {
        return this.http.get<APIResponse>(this.contactUrl + 'GetRecordTypes/');
    }

    public getRecordLockByID(recordLockId: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetRecordLockByID/?id=' + recordLockId);
    }

    public getRecordLockByRecordTypeIDRecordID(recordTypeId: number, recordId: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetRecordLockByRecordTypeIDRecordID/?recordTypeId=' + recordTypeId + '&recordId=' + recordId);
    }

    public getAllRecordLockByRecordTypeID(recordTypeId: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetAllRecordLockByRecordTypeID/?recordTypeId=' + recordTypeId);
    }

    public clearRecordLockByID(recordLockID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'ClearRecordLockByID/?recordLockID=' + recordLockID + '&employeeID=' + employeeID);
    }

    public clearRecordLockByRecordTypeEmployee(recordTypeID: number, employeeID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'ClearRecordLockByRecordTypeIDEmployeeID/?recordTypeId=' + recordTypeID + '&employeeId=' + employeeID);
    }

    public clearRecordLockByRecordTypeEmployeeRecord(recordTypeID: number, employeeID: number, recordID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'ClearRecordLockByRecordTypeIDEmployeeIDRecordID/?recordTypeId=' + recordTypeID + '&employeeId=' + employeeID + '&recordid=' + recordID);
    }

    public clearRecordLockByLockSource(recordTypeID: number, employeeID: number, recordID: number, lockSource: string) {
        return this.http.get<APIResponse>(this.contactUrl + 'ClearRecordLockByLockSource/?recordTypeID=' + recordTypeID + '&employeeID=' + employeeID + '&recordID=' + recordID + '&lockSource=' + lockSource);
    }

    public clearRecordLockListByLockSource(recordTypeID: number, employeeID: number, recordIDList: number[], lockSource: string) {
        var idList: string = recordIDList.join(",");
        return this.http.get<APIResponse>(this.contactUrl + 'ClearRecordLockListByLockSource/?recordTypeID=' + recordTypeID + '&employeeID=' + employeeID + '&recordIDList=' + idList + '&lockSource=' + lockSource);
    }

    public overrideRecordLockByLockSource(recordTypeID: number, employeeID: number, recordID: number, lockSource: string) {
        return this.http.get<APIResponse>(this.contactUrl + 'OverrideRecordLockByLockSource/?recordTypeID=' + recordTypeID + '&employeeID=' + employeeID + '&recordID=' + recordID + '&lockSource=' + lockSource);
    }

    public saveRecordLock(recordLock: RecordLock) {
        return this.http.post<APIResponse>(this.contactUrl + 'SaveRecordLock', recordLock, httpOptions);
    }

    public saveRecordLockList(recordLockList: RecordLock[]) {
        return this.http.post<APIResponse>(this.contactUrl + 'SaveRecordLockList', recordLockList, httpOptions);
    }

    public getSearchRecordLockByID(recordLockId: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetSearchRecordLockByID/?id=' + recordLockId);
    }

    public getAllSearchRecordLockByRecordTypeID(recordTypeID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetAllSearchRecordLockByRecordTypeID/?recordTypeId=' + recordTypeID);
    }

    public getAllSearchRecordLockByRecordTypeName(recordTypeName: string) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetAllSearchRecordLockByRecordTypeName/?recordTypeName=' + recordTypeName);
    }

    public getSearchRecordLockByRecordTypeNameRecordID(recordTypeName: string, recordID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetSearchRecordLockByRecordTypeNameRecordID/?recordTypeName=' + recordTypeName + '&recordId=' + recordID);
    }

    public getSearchRecordLockByRecordTypeNameRecordIDList(recordTypeName: string, recordIDList: number[]) {
        var idList: string = recordIDList.join(",");
        return this.http.get<APIResponse>(this.contactUrl + 'GetSearchRecordLockByRecordTypeNameRecordIDList/?recordTypeName=' + recordTypeName + '&recordIDList=' + idList);
    }
}